import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  Wrapper,
  Content,
  Text,
  Line,
  Link,
  ButtonWrapper,
} from "./styles/internet-explorer-support";

const InternetExplorerSupport = ({ closeIeMessage, top }) => (
  <Wrapper className="animated fadeInDown delay" top={top}>
    <Content>
      <Text>
        <Line>
          Please note that <strong>Hiring Hub</strong> no longer supports{" "}
          <strong>Internet Explorer</strong>.
        </Line>
        <Line>
          We recommend upgrading to the latest{" "}
          <Link
            href="https://www.microsoft.com/en-gb/windows/microsoft-edge/"
            title="Microsoft Edge"
          >
            Microsoft Edge
          </Link>
          ,{" "}
          <Link href="https://www.google.com/chrome/" title="Google Chrome">
            Google Chrome
          </Link>{" "}
          or{" "}
          <Link
            href="https://www.mozilla.org/en-GB/firefox/new/"
            title="Mozilla Firefox"
          >
            Mozilla Firefox
          </Link>
          .
        </Line>
      </Text>
      <ButtonWrapper onClick={() => closeIeMessage()}>
        <FontAwesomeIcon icon={faTimes} />
      </ButtonWrapper>
    </Content>
  </Wrapper>
);

InternetExplorerSupport.propTypes = {
  closeIeMessage: PropTypes.func.isRequired,
  top: PropTypes.string,
};

InternetExplorerSupport.defaultProps = {
  top: PropTypes.isNull,
};

export default InternetExplorerSupport;
